<template>
  <div class="audio-player">
    <episodes class="bot-marged" ref="episodes" @selectEpisode="selectEpisode" :currentEpisode="currentEpisode"/>
    <div class="fixed">
      <div class="shadow"></div>
      <audio-controls :episode="currentEpisode" @next="next" @previous="previous" />
    </div>
  </div>
</template>

<script>
import Episodes from '@/components/Episodes'
import AudioControls from '@/components/AudioControls'
export default {
  name: 'audio-player',
  components: { Episodes, AudioControls },
  props: ['episodeId'],
  data () {
    return {
      currentEpisode: null
    }
  },
  methods: {
    selectEpisode (episode) {
      this.currentEpisode = episode
    },
    next (isRandom) {
      this.$refs.episodes.next(isRandom)
    },
    previous (isRandom) {
      this.$refs.episodes.previous(isRandom)
    }
  },
  mounted () {
    this.$refs.episodes.initWithEpisodeId(this.episodeId)
  }
}
</script>

<style scoped lang="scss">

.audio-player {
  max-width: 500px;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  min-height: 100vh;
  box-shadow: 0 0px 6px rgba(0, 0, 0, 0.479);
  background-color: $whitish;
}

.fixed {
  position: fixed;
  bottom: 0;
  max-width: 500px;
  height: calc(145px + 15px);
  width: 100%;
}
.bot-marged {
  padding-bottom: 145px;
  padding-top: 45px;
}

.shadow {
  background: linear-gradient(rgba(0,0,0,0), rgba(0,0,0,.5));
  height: 15px;
}
</style>
